import './lodash-filters'
import './moment-filters'
import './money-filters'
import './number-filters'
import './text-filters'

import '@/products/filters/product-categories'
import '@/logwood/filters/logwood-package-filters'